<template>
  <div id="app">
    <inncosys-header v-if="userIsAuthenticated" ></inncosys-header>
    <inncosys-side-nav v-if="userIsAuthenticated" ></inncosys-side-nav>   
    <router-view v-if="!userIsAuthenticated" name="login"></router-view>
    <router-view v-if="userIsAuthenticated"></router-view>
    <inncosys-footer v-if="userIsAuthenticated" ></inncosys-footer>
  </div>
</template>

<script>
import Header from './components/master/Header.vue';
import SideNav from './components/master/SideNav.vue';
import Footer from './components/master/Footer.vue';

export default {
  name: 'app',
  created() {
  },
  mounted() {
    const instanceBellNotification = M.Dropdown.init(
      document.getElementById('bellNotification'),
      {
        coverTrigger: false,
        hover: true,
        constrainWidth: false,
      },
    );
    const sideNavElem = document.querySelector('.sidenav');
    const instance = M.Sidenav.init(sideNavElem);
  },
  components: {
    inncosysHeader: Header,
    inncosysSideNav: SideNav,
    inncosysFooter: Footer,
  },
  computed: {
    userIsAuthenticated() {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      );
    },
  },
  methods: {
    onLogout() {
      this.$store.dispatch('logout');
    },
  },
};
</script>

<style>
 html,
    body,
    .height-full {
      height: 100%;
    }
main,
footer {
  padding-left: 300px;
}
#app {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}
main {
  flex: 1 0 auto;
  margin-top: 64px;
  background-color: #f5f5f6;
  min-height: 100%;
}
footer {
  position: fixed;
  bottom: 0;
  width: 100%;
}
.btn-floating {
  bottom: 43px;
}
@media only screen and (max-width: 992px) {
  header,
  main,
  footer {
    padding-left: 0;
  }
}
@media only screen and (min-width: 992px) {
  .sidenav-fixed {
    margin-top: 64px !important;
    
  }
}

.background-round {
  background-color: rgba(0, 0, 0, 0.18);
  padding: 15px;
  border-radius: 50%;
}

.notification-badge {
  position: relative;
  right: 5px;
  top: -20px;
  color: #ffffff !important;
  background-color: var(--primary-dark-color);
  margin: 0 -0.8em;
  border-radius: 50%;
  padding: 4px 5px;
}
small {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif !important;
  font-size: 0.8rem;
}
#app {
  height: 100%;
  background-color: #f5f5f6;
}

/*Color Scheme*/
:root {
  --primary-color: #009447;
  --primary-light-color: #009447;
  --primary-light-color-alpha40: #ffc8008e;
  --primary-dark-color: #00651c;
  --secondary-color: #ffc800;
  --secondary-light-color: #fffb50;
  --secondary-dark-color: #c79800;
}
.collection .collection-item.active {
  background-color: var(--primary-dark-color);
}

.collection a.collection-item {
  color: var(--primary-dark-color);
}

.progress .determinate {
  background-color: var(--primary-dark-color);
}

.progress .indeterminate {
  background-color: var(--primary-dark-color);
}

span.badge.new {
  background-color: var(--primary-dark-color);
}

.btn,
.btn-large {
  background-color: var(--secondary-color);
}

.btn-floating {
  background-color: var(--secondary-color);
}

.btn-floating:hover {
  background-color: var(--secondary-dark-color);
}

.notification-badge {
  background-color: var(--primary-dark-color);
}
.fixed-action-btn .fab-backdrop {
  background-color: var(--primary-dark-color);
}

.dropdown-content li > a,
.dropdown-content li > span {
  color: var(--primary-dark-color);
}

.chips.focus {
  border-bottom: 1px solid var(--primary-dark-color);
  -webkit-box-shadow: 0 1px 0 0 var(--primary-dark-color);
  box-shadow: 0 1px 0 0 var(--primary-dark-color);
}

.chips .chip.selected {
  background-color: var(--primary-dark-color);
}

input:not([type]):focus:not([readonly]),
input[type="text"]:not(.browser-default):focus:not([readonly]),
input[type="password"]:not(.browser-default):focus:not([readonly]),
input[type="email"]:not(.browser-default):focus:not([readonly]),
input[type="url"]:not(.browser-default):focus:not([readonly]),
input[type="time"]:not(.browser-default):focus:not([readonly]),
input[type="date"]:not(.browser-default):focus:not([readonly]),
input[type="datetime"]:not(.browser-default):focus:not([readonly]),
input[type="datetime-local"]:not(.browser-default):focus:not([readonly]),
input[type="tel"]:not(.browser-default):focus:not([readonly]),
input[type="number"]:not(.browser-default):focus:not([readonly]),
input[type="search"]:not(.browser-default):focus:not([readonly]),
textarea.materialize-textarea:focus:not([readonly]) {
  border-bottom: 1px solid var(--primary-dark-color);
  -webkit-box-shadow: 0 1px 0 0 var(--primary-dark-color);
  box-shadow: 0 1px 0 0 var(--primary-dark-color);
}

input:not([type]):focus:not([readonly]) + label,
input[type="text"]:not(.browser-default):focus:not([readonly]) + label,
input[type="password"]:not(.browser-default):focus:not([readonly]) + label,
input[type="email"]:not(.browser-default):focus:not([readonly]) + label,
input[type="url"]:not(.browser-default):focus:not([readonly]) + label,
input[type="time"]:not(.browser-default):focus:not([readonly]) + label,
input[type="date"]:not(.browser-default):focus:not([readonly]) + label,
input[type="datetime"]:not(.browser-default):focus:not([readonly]) + label,
input[type="datetime-local"]:not(.browser-default):focus:not([readonly])
  + label,
input[type="tel"]:not(.browser-default):focus:not([readonly]) + label,
input[type="number"]:not(.browser-default):focus:not([readonly]) + label,
input[type="search"]:not(.browser-default):focus:not([readonly]) + label,
textarea.materialize-textarea:focus:not([readonly]) + label {
  color: var(--primary-dark-color);
}

.input-field .prefix.active {
  color: var(--primary-dark-color);
}

[type="radio"]:checked + label:after,
[type="radio"].with-gap:checked + label:before,
[type="radio"].with-gap:checked + label:after {
  border: 2px solid var(--primary-dark-color);
}

[type="radio"]:checked + label:after,
[type="radio"].with-gap:checked + label:after {
  background-color: var(--primary-dark-color);
}

[type="checkbox"]:checked + label:before {
  border-right: 2px solid var(--primary-dark-color);
  border-bottom: 2px solid var(--primary-dark-color);
}

/* Indeterminate checkbox */

[type="checkbox"]:indeterminate + label:before {
  border-right: 2px solid var(--primary-dark-color);
}

[type="checkbox"].filled-in:checked + label:after {
  border: 2px solid var(--primary-dark-color);
  background-color: var(--primary-dark-color);
}

[type="checkbox"].filled-in.tabbed:checked:focus + label:after {
  background-color: var(--primary-dark-color);
  border-color: var(--primary-dark-color);
}

.switch label input[type="checkbox"]:checked + .lever:after {
  background-color: var(--primary-dark-color);
}

input[type="range"] + .thumb {
  background-color: var(--primary-dark-color);
}

input[type="range"] + .thumb .value {
  color: var(--primary-dark-color);
}

input[type="range"]::-webkit-slider-thumb {
  background-color: var(--primary-dark-color);
}

input[type="range"]::-moz-range-thumb {
  background: var(--primary-dark-color);
}

input[type="range"]::-ms-thumb {
  background: var(--primary-dark-color);
}

.side-nav li > a.btn-floating:hover {
  background-color: var(--secondary-dark-color);
}

.spinner-layer {
  border-color: var(--primary-dark-color);
}

.picker__date-display {
  background-color: var(--primary-dark-color);
}

.picker__day.picker__day--today {
  color: var(--primary-dark-color);
}

.picker__day--selected,
.picker__day--selected:hover,
.picker--focused .picker__day--selected {
  background-color: var(--primary-dark-color);
}

.picker__close,
.picker__today,
.picker__clear {
  color: var(--primary-dark-color);
}

.clockpicker-canvas-bearing {
  stroke: none;
  fill: var(--primary-dark-color);
}

.clockpicker-canvas-bg {
  stroke: none;
  fill: var(--primary-dark-color);
}

.clockpicker-canvas-bg-trans {
  fill: var(--primary-dark-color);
}

.clockpicker-canvas line {
  stroke: var(--primary-dark-color);
}
.btn:hover,
.btn-large:hover {
  background-color: var(--secondary-dark-color);
}
.side-nav li > a.btn:hover,
.side-nav li > a.btn-large:hover,
.side-nav li > a.btn-large:hover {
  background-color: var(--primary-light-color);
}
.timepicker-canvas-bg {
  fill: var(--primary-color);
}
.timepicker-canvas line {
  stroke: var(--primary-color);
}
.timepicker-canvas-bearing {
  fill: var(--primary-color);
}
.sidenav .collapsible-body > ul:not(.collapsible) > li.active, .sidenav.sidenav-fixed .collapsible-body > ul:not(.collapsible) > li.active{
  background-color: var(--primary-color)!important;
}
.sidenav .collapsible-body > ul:not(.collapsible) > li.active, .sidenav.sidenav-fixed .collapsible-body > ul:not(.collapsible) > li.active a{
  color:black;
}
.sidenav  li.active{
  background-color: var(--secondary-color);
}
.sidenav  li.active a{
  color:black;
}
</style>
